<div *ngIf="busy">Fetching data...</div>

<div *ngIf="!busy && loggedInPlayer.ladderType != 'Tiebreak'" class="players">

  <button *ngIf="!waitingRoom && loggedInPlayer.levelId != 1" class="btn btn-primary" (click)="bulkemailopponents($event)" [disabled]="busyEmail">Email All (unplayed) Opponents</button>
<div *ngIf="busyEmail">
  Emailing.... Please wait...
</div>

  <br />

  <div align="right" style="text-align: right">
    <label>
      Show Photos
      <input type="checkbox" [(ngModel)]="showAvatar" (ngModelChange)="showAvatarChanged($event)" />
    </label>
  </div>
  <table class="table table-bordered table-striped">
    <thead class="thead-green">
      <tr>
        <th *ngIf="loggedInPlayer.isDoubles">Team</th>
        <th>Player</th>
        <th *ngIf="!waitingRoom" style="text-align:center;">Email</th>
        <th *ngIf="!waitingRoom" style="text-align:center;">Phone</th>
        <th *ngIf="!waitingRoom" style="text-align:center;" class="show-small">Text</th>
      </tr>
    </thead>


    <tbody class="table-striped">
      <ng-container *ngFor="let playerList of players">
        <tr>
          <td *ngIf="loggedInPlayer.isDoubles" [ngClass]="{'played':alreadyPlayedIds.includes(playerList[0].doublesId)}">
            <a title="View Record" [routerLink]="['/player',playerList[0].doublesId]">{{playerList[0].doublesName}}</a>
          </td>
          <td>
            <div *ngFor="let player of playerList"
              [ngClass]="{'played': alreadyPlayedIds.includes(player.id), 'played':alreadyPlayedIds.includes(player.doublesId)}">

              <img *ngIf="showAvatar" class="hide-small" [src]="player.avatar || '/assets/avatar.png'" height="70" width="70"
                style="border-radius: 50%; border: 3px solid black;" />
              <img *ngIf="showAvatar" class="show-small" [src]="player.avatar || '/assets/avatar.png'" height="60" width="60"
                style="border-radius: 50%; border: 3px solid black;" />
              <br *ngIf="showAvatar" />

              <!-- for Doubles or Waiting Room, don't make them links/clickable -->
              <span *ngIf="!loggedInPlayer.isDoubles && !waitingRoom"><a title="View Record"
                  [routerLink]="['/player',player.id]">{{player.getFullName()}}</a><sup>{{player.rank||'N/R'}}</sup></span>
              <span *ngIf="loggedInPlayer.isDoubles || waitingRoom">{{player.getFullName()}}<sup>{{player.rank||'N/R'}}</sup></span>

              <span *ngIf="player.message">
                <br />
                <span class="msg-text">{{player.message}}</span>
              </span>
            </div>
          </td>
          <td *ngIf="!waitingRoom" class="hide-small">
            <div *ngFor="let player of playerList" [ngClass]="{'played': alreadyPlayedIds.includes(player.id)}">
              <span><a title="Email Player" target="_blank" href="mailto:{{player.email}}">{{player.email}}</a></span>
            </div>
          </td>
          <td *ngIf="!waitingRoom" class="show-small" align="center">
            <div *ngFor="let player of playerList" [ngClass]="{'played': alreadyPlayedIds.includes(player.id)}">
              <a title="Email Player" target="_blank" href="mailto:{{player.email}}">
                <fa-icon [icon]="faEnvelope" size="2x"></fa-icon>
              </a>
            </div>
          </td>
          <td *ngIf="!waitingRoom" class="hide-small">
            <div *ngFor="let player of playerList" [ngClass]="{'played': alreadyPlayedIds.includes(player.id)}">
              <span>{{player.phoneNumber}}</span>
            </div>
          </td>
          <td *ngIf="!waitingRoom" class="show-small" align="center">
            <div *ngFor="let player of playerList" [ngClass]="{'played': alreadyPlayedIds.includes(player.id)}">
              <a title="Call Player" href="tel:{{player.phoneNumber}}">
                <fa-icon [icon]="faPhone" size="2x"></fa-icon>
              </a>
            </div>
          </td>
          <td *ngIf="!waitingRoom" class="show-small" align="center">
            <div *ngFor="let player of playerList" [ngClass]="{'played': alreadyPlayedIds.includes(player.id)}">
              <a title="Text Player" [href]="'sms:'+player.phoneNumber|safeUrl">
                <fa-icon [icon]="faText" size="2x"></fa-icon>
              </a>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  NOTE: Ranking A-E is only an indication of your rank compared to other players in the Lubin Ladder list. This has nothing
  to do with USTA rankings.
  <br /><br />
  

</div>



<div *ngIf="!busy && loggedInPlayer.ladderType == 'Tiebreak'" class="players">
  <div style="display: flex; flex-wrap: wrap;">
    <ng-container *ngFor="let playerList of players; let idx = index">
      <ng-container *ngFor="let player of playerList; let idx = index">
        <div style="flex: 1 1 auto; margin: auto auto;text-align:center;">
          <img [routerLink]="['/player',player.id]" [src]="player.avatar || '/assets/avatar.png'" height="170" width="170"
            style="border: 2px solid black;" />
          <br />
          {{player.getFullName()}}
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
